import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.25),
  },

  icon: {
    width: theme.spacing(1.875),
    height: theme.spacing(1.875),
    objectFit: 'contain',
    margin: 'auto',
    color: 'white',
  },
}));
